import type { Locale } from "@/lib/i18n";
import { pl, type CVideoGalleryOuterTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cVideoGalleryOuterTranslations: Record<
  Locale,
  CVideoGalleryOuterTranslations
> = {
  pl,
  en,
  de,
};

export type { CVideoGalleryOuterTranslations };
